import React from 'react';
import './ApplicantsList.css';

function ApplicantsList({
  applicants,
  searchTerm,
  setSearchTerm,
  selectedJobTitle,
  setSelectedJobTitle,
  jobTitles,
  onView,
}) {
  return (
    <div className="Applicants-list">
      <div className="applicants-header">
        <div className="applicants-controls">
          <input
            type="text"
            placeholder="Search by name or email"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-bar"
          />
          <select
            className="job-filter"
            value={selectedJobTitle}
            onChange={(e) => setSelectedJobTitle(e.target.value)}
          >
            <option value="">All Categories</option>
            {jobTitles.map((title) => (
              <option key={title} value={title}>{title}</option>
            ))}
          </select>
        </div>
      </div>

      <table className="applicants-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Job Title</th>
            <th>Date Applied</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {applicants.length === 0 ? (
            <tr>
              <td colSpan="6" style={{ textAlign: 'center' }}>No applicants found.</td>
            </tr>
          ) : (
            applicants.map((applicant, index) => (
              <tr key={applicant.id}>
                <td>{index + 1}</td>
                <td>{applicant.name}</td>
                <td>{applicant.email}</td>
                <td>{applicant.jobTitle}</td>
                <td>{applicant.dateApplied}</td>
                <td>
                  <button onClick={() => onView(applicant)} className="view-btn">
                    View
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ApplicantsList;
